import React from "react";

const ContactsIcon = ({ fill }) => (
  <svg
    id="Group_176"
    data-name="Group 176"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
  >
    <path id="Path_76" data-name="Path 76" d="M0,0H22V22H0Z" fill="none" />
    <path
      id="Path_77"
      data-name="Path 77"
      d="M13,24A11,11,0,1,1,24,13,11,11,0,0,1,13,24ZM7.514,19.882a8.8,8.8,0,0,0,11.169-.163,7.7,7.7,0,0,0-11.169.163ZM5.978,18.3a9.9,9.9,0,0,1,14.2-.2,8.8,8.8,0,1,0-14.2.206ZM13,14.1a4.4,4.4,0,1,1,4.4-4.4A4.4,4.4,0,0,1,13,14.1Zm0-2.2a2.2,2.2,0,1,0-2.2-2.2A2.2,2.2,0,0,0,13,11.9Z"
      transform="translate(-2 -2)"
      fill={fill}
    />
  </svg>
);

export default ContactsIcon;
